(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babylonjs"));
	else if(typeof define === 'function' && define.amd)
		define(["babylonjs"], factory);
	else if(typeof exports === 'object')
		exports["babylon_ros"] = factory(require("babylonjs"));
	else
		root["babylon_ros"] = factory(root["_"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__9859__) => {
return 